/**
 * French wording for the server's error codes.
 *
 * The API answers in English — `message` fields like "Your host role has not
 * been validated yet." are written for logs and for the mobile client, which
 * never shows them (it maps codes to its own catalogue and falls back to a
 * generic line). The admin panel had no such layer and rendered the raw
 * `message`, so an English sentence would appear mid-sentence in a French
 * interface.
 *
 * Only codes an operator can actually trigger are listed. Anything else falls
 * back to a generic French line rather than leaking English prose.
 */
const MESSAGES: Readonly<Record<string, string>> = {
  VALIDATION_ERROR: 'Certaines informations sont invalides ou incomplètes.',
  UNAUTHORIZED: 'Session expirée. Reconnectez-vous.',
  FORBIDDEN: 'Vous n’avez pas les droits nécessaires pour cette action.',
  NOT_FOUND: 'Introuvable.',
  OFFER_NOT_FOUND: 'Cette offre est introuvable.',
  USER_NOT_FOUND: 'Cet utilisateur est introuvable.',
  BOOKING_NOT_FOUND: 'Cette réservation est introuvable.',
  ALREADY_VALIDATED: 'Cet hôte est déjà validé.',
  NOT_HOST: 'Cet utilisateur n’a pas le rôle Hôte.',
  INVALID_STATUS: 'Le statut actuel ne permet pas cette action.',
  INVALID_STATE_TRANSITION: 'Le statut actuel ne permet pas cette action.',
  OFFER_INVALID_TRANSITION: 'Le statut actuel ne permet pas cette action.',
  INVALID_BOOKING_STATE: 'Le statut actuel ne permet pas cette action.',
  IDEMPOTENCY_CONFLICT:
    'Cette action a déjà été envoyée. Actualisez avant de réessayer.',
  IDEMPOTENCY_REQUEST_IN_PROGRESS:
    'Cette action est déjà en cours de traitement.',
  TOO_LARGE: 'Ce fichier est trop volumineux.',
  INTERNAL_ERROR: 'Une erreur est survenue côté serveur.',
};

const GENERIC = 'Une erreur est survenue.';

export function frenchErrorMessage(
  code: string | undefined,
  status: number,
): string {
  if (code && MESSAGES[code]) return MESSAGES[code];
  if (status === 429)
    return 'Trop de tentatives. Réessayez dans une minute.';
  if (status >= 500) return MESSAGES.INTERNAL_ERROR;
  return GENERIC;
}
